// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/in_app_message_color_profiles" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementInAppMessageColorProfiles } from "./constants";
import type {
  EngagementInAppMessageColorProfilesDataTableResult,
  EngagementInAppMessageColorProfilesParams,
} from "./types";
import { isEngagementInAppMessageColorProfilesResult } from "./validators";

export const getDataTableEngagementInAppMessageColorProfiles = reactQueryTableFetcherAdapter(
  engagementInAppMessageColorProfiles,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementInAppMessageColorProfilesParams
  ): Promise<EngagementInAppMessageColorProfilesDataTableResult> => {
    return fetch(
      "/engagement/in_app_message_color_profiles",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementInAppMessageColorProfilesResult
);
